import { Avatar, Checkbox, MultiSelect, Select, Textarea } from "@mantine/core";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import InputField from "../../../components/inputField";
import Page from "../../../components/Page";
import { backendUrl } from "../../../constants";
import userLogo from "../../../assets/jobSeeker.png";
import { Text } from "@mantine/core";
import Cross from "../../../assets/remove.svg";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";
import "./styles.css";

const Index = ({ profileData, setProfileData }) => {
  const [industry, setIndustry] = useState([]);
  const [emp, setEmp] = useState([]);
  const [empStatus, setEmpStatus] = useState([]);
  const [files, setFiles] = useState([]);

  //Industry
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}industry/listIndustry`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.industryName };
          setIndustry((inds) => [...inds, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //employment type
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/jobType`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setEmp((emp) => [...emp, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //employment status
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/employmentStatus`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setEmpStatus((empStatus) => [...empStatus, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  const previews = files.map((file, index) => {
    const imageUrl = URL.createObjectURL(file);
    return (
      <Avatar
        size={250}
        key={index}
        src={imageUrl}
        radius="md"
        className="rounded-circle dp"
        imageProps={{ onLoad: () => URL.revokeObjectURL(imageUrl) }}
      />
    );
  });

  const removeImage = () => {
    setFiles([]);
    setProfileData((profileData) => ({
      ...profileData,
      jobSeekerProfileImage: "",
    }));
  };

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="profileInfo-main">
        <h2 className="text-dark text-center py-2">Profile Information</h2>
        <div className="main-1">
          <div className="profile-image">
            <div className="d-flex position-relative">
              {profileData?.jobSeekerProfileImage && (
                <img
                  src={Cross}
                  width="35px"
                  className="cross-icon"
                  onClick={removeImage}
                  alt="delete"
                />
              )}
              {files.length > 0 ? (
                previews
              ) : (
                <Avatar
                  size={250}
                  src={profileData?.jobSeekerProfileImage || userLogo}
                  className="rounded-circle dp"
                />
                // </div>
              )}
            </div>
            <Dropzone
              accept={IMAGE_MIME_TYPE}
              // onDrop={setFiles}
              maxFiles={1}
              style={{ width: "220px" }}
              onDrop={(v) => {
                setFiles(v);
                setProfileData((profileData) => ({
                  ...profileData,
                  jobSeekerProfileImage: v[0],
                }));
              }}
            >
              <Text align="center">Upload Profile Picture</Text>
            </Dropzone>
          </div>
          <div className="j-info-content">
            <div className="row d-flex">
              <div className="col-md-6">
                <InputField
                  placeholder={"First Name"}
                  required
                  label="First Name"
                  value={profileData?.firstName}
                  onChange={(v) =>
                    setProfileData((profileData) => ({
                      ...profileData,
                      firstName: v.target.value,
                    }))
                  }
                />
              </div>
              <div className="col-md-6">
                <InputField
                  required
                  placeholder={"Last Name"}
                  label="Last Name"
  
                  value={profileData?.lastName}
                  onChange={(v) =>
                    setProfileData((profileData) => ({
                      ...profileData,
                      lastName: v.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <InputField
              required
              label="Email"
              value={profileData?.email}
              disabled={true}
            />
            <InputField
              placeholder={"Phone Number"}
              required
              type={"number"}
              label="Phone Number"
              value={profileData?.phoneNo}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  phoneNo: v.target.value,
                }))
              }
            />
            <Select
              label="Employment Status"
              placeholder="Select..."
              data={empStatus}
              value={profileData?.employmentStatus}
              maxDropdownHeight={400}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  employmentStatus: v,
                }))
              }
            />
            <InputField
              label={"Job Title"}
              value={profileData?.jobTitle}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  jobTitle: v.target.value,
                }))
              }
            />
            <Checkbox.Group
              label="Job Type"
              // size="xs"
              value={profileData?.employmentPreferences}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  employmentPreferences: v,
                }))
              }
            >
              <div className="d-flex w-100 row justify-content-between">
                {emp &&
                  emp.map((obj, key) => (
                    <Checkbox
                      classNames="col-md-6"
                      key={key}
                      value={obj.value}
                      label={obj.label}
                      className="w-50"
                      color="red"
                    />
                  ))}
              </div>
            </Checkbox.Group>
            <MultiSelect
              label="Desired Industry"
              placeholder="Select..."
              data={industry}
              // searchable
              value={profileData.jobSeekerIndustry}
              maxDropdownHeight={400}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  jobSeekerIndustry: v,
                }))
              }
            />
            <p style={{ margin: "0px", fontWeight: "500" }}>Salary Range</p>
            <div className="d-flex row gap-2">
              <div className="col-md-4">
                <Select
                  label="Salary Type"
                  defaultValue={"hourly"}
                  data={[
                    { label: "Hourly", value: "hourly" },
                    { label: "Monthly", value: "monthly" },
                  ]}
                  maxDropdownHeight={400}
                  className="h-100"
                  onChange={(v) =>
                    setProfileData((profileData) => ({
                      ...profileData,
                      salaryRange: v,
                    }))
                  }
                />
              </div>
              <div className="col-md-3">
                <InputField
                  label="Min Salary"
                  placeholder="$$$$$$"
                  style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
                  value={profileData?.minSalary}
                  onChange={(v) =>
                    setProfileData((profileData) => ({
                      ...profileData,
                      minSalary: v.target.value,
                    }))
                  }
                />
              </div>
              <div className="col-md-3">
                <InputField
                  label="Max Salary"
                  placeholder="$$$$$$"
                  style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
                  value={profileData?.maxSalary}
                  onChange={(v) =>
                    setProfileData((profileData) => ({
                      ...profileData,
                      maxSalary: v.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div className="row f-flex align-items-end">
              <div className="col-md-6">
                <InputField
                  placeholder={"Zip Code"}
                  label="Zip Code"
                  value={profileData?.zipCode}
                  onChange={(v) =>
                    setProfileData((profileData) => ({
                      ...profileData,
                      zipCode: v.target.value,
                    }))
                  }
                />
              </div>
              <Checkbox
                label="Willing to Relocate."
                color="red"
                className="col-md-6"
                checked={profileData.relocate}
                onChange={(v) =>
                  setProfileData((profileData) => ({
                    ...profileData,
                    relocate: v.target.checked,
                  }))
                }
              />
            </div>
            <Textarea
              placeholder="eg. Highly Motivated seniorlevel software developer with exceptional skills"
              label="Summary"
              defaultValue={profileData?.summary}
              onChange={(v) =>
                setProfileData((profileData) => ({
                  ...profileData,
                  summary: v.target.value,
                }))
              }
            />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
